import React, {useRef, useEffect, useState} from "react"
import ReactDOM from 'react-dom'
import { graphql, Link, navigate } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import styled from "styled-components"
import { CSSTransition } from "react-transition-group"

import { _raf, truncateString } from "../utils/helpers"
import CtaBanner from "../components/Common/CtaBanner";
import { categoryAccentClass } from "../utils/category-classes"

import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

import CtaCategories from "../components/Sections/CtaCategories"
// import SubscribeNewsletter from "../components/Sections/SubscribeNewsletter"
import FAQCollapse from "../components/Sections/FAQCollapse";
import BlogCta from "../components/Sections/BlogCta";
import ArticleSearchBar from "../components/Sections/ArticleSearchBar"
import SearchIcon from "../images/search-icon.svg"
import CloseIcon from "../images/close-icon.svg"
import queryString from "query-string";
import {useLocation} from "@reach/router";

const Hero = styled.div`
    .gatsby-image-wrapper img {
        height: auto !important;
        min-height: 534px;
        @media screen and (max-width: 767px) {
            min-height: 360px;
        }
    }
`
const PostHeader = styled.div`
    .author-box{
        text-transform: capitalize;
        margin-right: 12px;
        padding-right: 20px;
        position: relative;
        &:after {
            content: '|';
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    @media screen and (min-width: 848px) {
        max-width: 720px;
        margin-top: -10%;
        z-index: 10;
        border-radius: 10px 10px 0 0;
        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1),
            0 15px 12px rgba(0, 0, 0, 0.06);
    }
`

const SocialShare = styled.div`
    display: flex;
    align-items: center;
    border-top: 1px dashed var(--gray);
    @media screen and (min-width: 848px) {
        border-top: none;
    }
    .social-share {
        &__list {
            display: flex;
            margin-left: var(--space-xs);
        }
    }
    svg {
        margin: 0 var(--space-xs);
        width: 24px;
        height: 24px;
        cursor: pointer;
    }
`

const SearchSection = styled.div`
    position: relative;
    &.has-form {
        @media screen and (max-width: 767px) {
            display: flex;
            flex-direction: column-reverse;
        }
        .search-icon {
            @media screen and (max-width: 767px) {
                left: -2px;
                top: 8px;
            }
        }
    }
    .search-bar{
        background-color: rgba(255,255,255,0.6);
    }
    .search-icon {
        outline: 0;
        position: absolute;
        top: 23px;
        right: 1rem;
        z-index: 20;
        padding: 10px;
        background: rgba(51,51,51,0.5);
        border-radius: 50%;
        width: 44px;
        height: 44px;
        
        &-wrap {
            text-align: right;
            position: relative;
            z-index: 20;
        }
        img{
            width: 22px;
            height: 22px;
        }
    }
`

export default ({ data }) => {
    const post = data.wordpressPost;
    const newAuthor = data.allWordpressAcfNewAuthors.nodes[0];
    const { title, content, date, featured_media, categories, slug, acf, author } = post
    const { faq_rc } = acf || {}
    const modified = post.modified === date ? false : post.modified
    const authorSlug = author.name.toLowerCase().replace(' ', '-');
    const [showWidget, setShowWidget] = useState(false)
    const [showSearchBar, setShowSearchBar] = useState(false)
    const [showBackToIchra, setShowBackToIchra] = useState(false)
    let leadType = 'ifp';
    if (categories[0].name === "Small Business") {
        leadType = "smb";
    } else if (categories[0].name === "Medicare") {
        leadType = "med";
    }
    const postHeaderEl = useRef()

    // Pick up the CTA section if exist
    const ctaSections = content.match(/<cta-block\s(.*?)>(.*?)<\/cta-block>/g);
    let contentWithCta = content;
    if(ctaSections && ctaSections.length > 0){
        ctaSections.forEach((cta, id) => {
            const ctaNew = cta.replace(/<cta-block/, `<cta-block id="cta-section-wrapper-${id}"`)
            contentWithCta = contentWithCta.replace(cta, ctaNew);
        });
    }
    const location = useLocation();
    const { fromIchraPage } = queryString.parse(location.search);
    useEffect(() => {
        if (fromIchraPage === "true"){
            sessionStorage.setItem('fromICHRAPage', 'true');
        }
        sessionStorage.getItem('fromICHRAPage') === 'true' ? setShowBackToIchra(true) : setShowBackToIchra(false);
    }, []);

    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: categories[0].slug,
                name: `post:${truncateString(slug, 50)}`,
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })

        window.addEventListener("scroll", () => {
            _raf()(() => {
                window.pageYOffset > 2000
                    ? setShowWidget(true)
                    : setShowWidget(false)
            })
        })

        if(ctaSections && ctaSections.length > 0){
            ctaSections.forEach((cta, id) => {
                const ctaWrapper = document.getElementById(`cta-section-wrapper-${id}`);
                if(ctaWrapper){
                    const ctaHeadLine = ctaWrapper.getAttribute('headline');
                    const ctaMessage = ctaWrapper.getAttribute('message');
                    const ctaColor = ctaWrapper.getAttribute('color');
                    const ctaBtn = ctaWrapper.getAttribute('cta-text');
                    const censusPage = ctaWrapper.getAttribute('census-page');
                    const blogCtaSection = <BlogCta id={`cta-section-${id}`} category={censusPage} headline={ctaHeadLine} message={ctaMessage} color={ctaColor} ctaBtn={ctaBtn}/>;
                    ReactDOM.render(blogCtaSection, document.getElementById(`cta-section-wrapper-${id}`));
                }
            });
        }
    }, [slug, categories])

    return (
        <>
            <SEO {...post} article author={author} newAuthor={newAuthor} pageType="resources"/>
            <div className="ehi-header--spacer"></div>
            {featured_media && featured_media.localFile && (
                <Hero className="hero">
                    <Img
                        fluid={featured_media.localFile.childImageSharp.fluid}
                        objectFit="cover"
                        objectPosition="50% 50%"
                        alt=""
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            transformOrigin: "75% center",
                            animation: `ken-burns 10s var(--cubic-bezier) forwards`,
                        }}
                    />
                    {/* <ArticleSearchBar /> */}
                    <SearchSection className={showSearchBar ? 'has-form' : ''}>
                        <div className="container search-icon-wrap">
                            <button className="search-icon" type="button" onClick={e=>{
                                setShowSearchBar(!showSearchBar);
                            }}>
                                <img src={showSearchBar ? CloseIcon : SearchIcon}/>
                            </button>
                        </div>

                        {showSearchBar && (
                            <ArticleSearchBar />
                        )}
                    </SearchSection>
                </Hero>
            )}
            <div className="container container--grid" ref={postHeaderEl}>
                <PostHeader className="container__row bg-white phablet:w-4-5 mx-auto tablet:w-full mx-md-0 pt-4 pb-0 py-md-4 px-md-5 rounded">
                    <div className="d-flex align-items-center mt-2 mb-2">
                        <p className="mb-0 mr-3 p-0 h5">{categories[0].name}</p>
                        <div
                            className={categoryAccentClass[categories[0].slug]}
                            style={{
                                width: `28px`,
                                height: `4px`,
                            }}
                        />
                    </div>
                    <h1
                        className="headline mb-3"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    {modified ? (
                        <h6 className="font-weight-normal">
                           <span className="author-box">BY <a onClick={() => window.open(`/author/${authorSlug}`, '_blank')} href="javascript:void(0)" title={author.name}>{author.name}</a></span> Updated on {modified}
                        </h6>
                    ) : (
                        <h6 className="font-weight-normal">
                            <span className="author-box">BY <a onClick={() => window.open(`/author/${authorSlug}`, '_blank')} href="javascript:void(0)" title={author.name}>{author.name}</a></span> Published on {date}
                        </h6>
                    )}
                </PostHeader>
                <SocialShare className="container__row mx-md-0 py-3 py-md-4 px-md-5">
                    <p className="mb-0">Share</p>
                    <div className="social-share__list">
                        <svg
                            className="facebook"
                            xmlns="http://www.w3.org/2000/svg"
                            data-wa-link="post:facebook"
                            viewBox="0 0 32 32"
                            onClick={() =>
                                window.open(
                                    `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
                                        window.location
                                    )}`,
                                    "facebookshare",
                                    "toolbar=0, status=0, width=650, height=450"
                                )
                            }
                        >
                            <path fill="none" d="M0 0h32v32H0z" />
                            <path
                                d="M17.53 26H13V16h-2v-3h2v-2.52a4.76 4.76 0 0 1 1.21-3.29A5 5 0 0 1 17.88 6H21v3h-2.09a1.5 1.5 0 0 0-1.17.57 3.53 3.53 0 0 0-.2 1.37V13h3.12l-.36 3h-2.77v10z"
                                fill="#231f20"
                                data-name="&lt;Group&gt;"
                            />
                        </svg>

                        <svg
                            className="twitter"
                            xmlns="http://www.w3.org/2000/svg"
                            data-wa-link="post:twitter"
                            viewBox="0 0 32 32"
                            onClick={() =>
                                window.open(
                                    `http://twitter.com/intent/tweet?text=${title}&url=${encodeURIComponent(
                                        window.location
                                    )}`,
                                    "twittershare",
                                    "toolbar=0, status=0, width=794, height=413"
                                )
                            }
                        >
                            <path fill="none" d="M0 0h32v32H0z" />
                            <path
                                d="M27 9.17a9.37 9.37 0 0 1-2.26 2.34v.58a12.7 12.7 0 0 1-3.31 8.66 12.1 12.1 0 0 1-9.52 4.19A12.52 12.52 0 0 1 5 22.9a7.79 7.79 0 0 0 1.08.1 8.79 8.79 0 0 0 5.6-2 4.29 4.29 0 0 1-2.63-.9 4.43 4.43 0 0 1-1.59-2.23 4.64 4.64 0 0 0 .85.08 4.8 4.8 0 0 0 1.2-.15A4.4 4.4 0 0 1 6 13.41v-.06a5.69 5.69 0 0 0 2 .56 4.31 4.31 0 0 1-2-3.75 4.45 4.45 0 0 1 .59-2.28 12.29 12.29 0 0 0 9.28 4.72 5.12 5.12 0 0 1-.11-1 4.51 4.51 0 0 1 4.51-4.51 4.33 4.33 0 0 1 3.29 1.43 9 9 0 0 0 2.87-1.11 4.38 4.38 0 0 1-2 2.51A9.23 9.23 0 0 0 27 9.17z"
                                fill="#231f20"
                                data-name="&lt;Group&gt;"
                            />
                        </svg>

                        <svg
                            className="linkedin p-xxxxs"
                            xmlns="http://www.w3.org/2000/svg"
                            data-wa-link="post:linkedin"
                            viewBox="0 0 32 32"
                            onClick={() =>
                                window.open(
                                    `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                                        window.location
                                    )}`,
                                    "skypeshare",
                                    "toolbar=0, status=0, width=650, height=450"
                                )
                            }
                        >
                            <path fill="none" d="M0 0h32v32H0z" />
                            <path d="M4 10h5v16H4V10zm2.65-7.81A2.84 2.84 0 1 1 3.81 5a2.84 2.84 0 0 1 2.84-2.81M12 10h5v2h.3A5.82 5.82 0 0 1 22 9.55c5 0 6 3.36 6 7.61V26h-5v-7.86c0-1.83-.29-4.18-2.8-4.18S17 15.95 17 18v8h-5V10z" />
                        </svg>
                    </div>
                </SocialShare>
            </div>
            <section className="container container--grid pt-4">
                <div className="container__row">
                    {showBackToIchra ? <span onClick={() => {
                        if (window._waEvents) {
                            window._waEvents.push("trackEvent", {
                                page: {
                                    action: 'back'
                                }
                            });
                        }
                    }}><Link to={`https://www.${process.env.GATSBY_SUBDOMAIN || ""}ehealthinsurance.com/small-business-health-insurance/ichra`}>{`< Back`}</Link></span> : ''}
                    <div
                        className="wysiwyg"
                        dangerouslySetInnerHTML={{ __html: contentWithCta}}
                    >
                    </div>
                </div>
            </section>
            {faq_rc ? <FAQCollapse data={{faq_rc}}/> : ''}
            {/* <SubscribeNewsletter
                fromPage={slug}
                leadType={leadType}
            /> */}
            <div className="divider divider-bottom bg-green"></div>
            <CtaCategories />

            <CSSTransition
                in={showWidget}
                timeout={600}
                classNames="slide-up"
                unmountOnExit
            >
                <CtaBanner
                    fromPage={slug}
                    category={
                        (categories && categories[0].name) ||
                        "Individual and Family"
                    }
                />
            </CSSTransition>
        </>
    )
}

export const query = graphql`
    query($id: Int!, $name: String) {
        wordpressPost(wordpress_id: { eq: $id }) {
            title
            excerpt
            content
            slug
            date(formatString: "MMMM DD, YYYY")
            modified(formatString: "MMMM DD, YYYY")
            author {
                name
                slug
                acf {
                    author_info {
                      author_info_show
                      title
                    }
                }
            }
            categories {
                name
                slug
            }
            featured_media {
                source_url
                media_details {
                    width
                    height
                }
                localFile {
                    childImageSharp {
                        fluid(maxWidth: 2000, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
            }
            acf {
                faq_rc {
                    faqs_rc {
                        faq_question_rc
                        faq_answer_rc
                    }
                    title_rc
                }
            }
            yoast_meta {
                yoast_wpseo_metadesc
                yoast_wpseo_title
            }
        }
        allWordpressAcfNewAuthors(filter: {acf: {header: {name: {eq: $name }}}}) {
            nodes {
                id
                wordpress_id
                acf {
                    additional_info
                    descrption
                    detail_info {
                        desc
                        title
                    }
                    ehealth_editorial_guidelines
                    seo {
                        desc
                        slug
                        title
                    }
                    header {
                        job_title
                        name
                    }
                }
            }
        }
    }
`